"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Cache = /*#__PURE__*/function () {
  function Cache(data) {
    (0, _classCallCheck2["default"])(this, Cache);
    (0, _defineProperty2["default"])(this, "data", {});
    this.data = data;
  }
  (0, _createClass2["default"])(Cache, [{
    key: "set",
    value: function set(key, value) {
      this.data[key] = value;
    }
  }, {
    key: "get",
    value: function get(key, defaultValue) {
      if (key in this.data) {
        return this.data[key];
      }
      if (defaultValue !== undefined) {
        return defaultValue;
      }
      throw Error("There is no such key \"".concat(key, "\" in cache and no default value was provided"));
    }
  }, {
    key: "extract",
    value: function extract() {
      return this.data;
    }
  }]);
  return Cache;
}();
var _default = Cache;
exports["default"] = _default;